export default "__VITE_ASSET__2a446cbd__"